module.exports = __webpack_public_path__ + "static/media/carlos-lines.83307d22.jpeg";